import { Link } from "react-router-dom";
import { StockBadge } from "@/components/StockBadge";

export function ProductCard({ product, to, children, priceSlot }) {
  return (
    <div data-testid={`product-card-${product.sku}`} className="mc-card group flex flex-col overflow-hidden rounded-2xl">
      <Link to={to} className="relative block aspect-square overflow-hidden bg-white p-4">
        <img src={product.image_url} alt={product.name}
          className="h-full w-full object-contain transition-transform duration-500 group-hover:scale-105" />
        <div className="absolute left-3 top-3 rounded-full bg-black/60 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wider text-[#D4AF37] backdrop-blur">
          {product.brand}
        </div>
        {product.stock_status && (
          <div className="absolute right-3 top-3">
            <StockBadge status={product.stock_status} testId={`card-stock-${product.sku}`} />
          </div>
        )}
      </Link>
      <div className="flex flex-1 flex-col p-5">
        <Link to={to}>
          <h3 className="font-serif-display text-xl font-semibold text-slate-100 transition-colors group-hover:text-[#D4AF37]">{product.name}</h3>
        </Link>
        <div className="mt-1 flex flex-wrap gap-x-3 gap-y-1 text-xs text-[#94A3B8]">
          <span className="font-mono-data">{product.sku}</span>
          <span>•</span>
          <span>{product.pack_size}</span>
        </div>
        <div className="mt-2 flex-1 text-sm leading-relaxed text-[#94A3B8] line-clamp-2">{product.description}</div>
        {priceSlot}
        <div className="mt-4">{children}</div>
      </div>
    </div>
  );
}
